export default "__VITE_ASSET__BfdbLMa5__"